import { isIOS } from '@general/helpers';

const initVideoControls = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  const allVideos = rootEl.querySelectorAll('video');

  const getDeviceType = () => {
    const width = window.innerWidth;
    if (width < 992) return 'mobile';
    return 'desktop';
  };

  rootEl.querySelectorAll('.media__custom-controls').forEach((customControls) => {
    const mediaContainer = customControls.closest('.media__container');
    if (!mediaContainer) return;
    const videos = mediaContainer.querySelectorAll('video');
    if (videos.length <= 0) return;

    customControls.addEventListener('click', () => {
      const device = getDeviceType();

      const videosArray = Array.from(videos);
      const mediaClassName = device === 'mobile' ? 'media--mobile' : 'media--desktop';
      const filtered = videosArray.filter((video) => video.classList.contains(mediaClassName));
      const targetVideos = filtered.length ? filtered : videosArray;

      if (mediaContainer.classList.contains('playing')) {
        targetVideos.forEach((video) => video.pause());
      } else {
        targetVideos.forEach((video) => {
          if (isIOS) {
            video.muted = true;
          }
          video.play();
          video.muted = false;
        });
      }
    });
  });

  let currentDevice = getDeviceType();

  const pauseAllVideos = () => {
    allVideos.forEach((video) => video.pause());
    rootEl.querySelectorAll('.media__container.playing').forEach((container) => container.classList.remove('playing'));
  };

  allVideos.forEach((video) => {
    const container = video.closest('.media__container');

    video.addEventListener('play', () => {
      container.classList.add('playing');
    });

    video.addEventListener('pause', () => {
      container.classList.remove('playing');
    });

    video.addEventListener('ended', () => {
      container.classList.remove('playing');
    });
  });

  window.addEventListener('resize', () => {
    const newDevice = getDeviceType();
    if (newDevice !== currentDevice) {
      currentDevice = newDevice;
      pauseAllVideos();
    }
  });
};

export { initVideoControls };
